import { COLORS } from '../../colors';

export default {
  underline:{
    '&:before': {
      borderBottom: `1px solid ${COLORS.blue}`,
    }
  }
};
